import { store } from "@/store/store";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { controller_api } from "@/shared/dtos/dinamically_forms/controller_api";

@Module({
  namespaced: true,
  name: "publicModule",
  store,
  dynamic: true,
})
class publicModule extends VuexModule {
  public controller_api: controller_api[] = [];

  @Action({ commit: "onGetController_api" })
  public async getController_api() {
    return await ssmHttpService.get(API.public + "/swagger-endpoints");
  }

  @Mutation
  public onGetController_api(res: controller_api[]) {
    this.controller_api = res ? res.map((x) => new controller_api(x)) : [];
  }
}
export default getModule(publicModule);
